import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React from "react";

interface Props {
    title: string;
    text: string;
    isOpen: boolean;
    onClose: () => void;
}

const ErrorDialog = ({ title, text, isOpen, onClose }: Props): React.ReactElement => {
    return (
        <Dialog onClose={onClose} aria-labelledby="error" open={isOpen}>
            <DialogTitle id="error">{title}</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>{text}</Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onClose} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialog;
